module.exports = __webpack_public_path__ + "static/img/datikuang2.84c5a22.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/datikuang2.png
// module id = VB1y
// module chunks = 0